const awsExports = {
    Auth: {
        region: 'us-east-1',
        userPoolId: process.env.REACT_APP_STAGE === "DEV" ? 'us-east-1_1vcRUFEL9' : 'us-east-1_6kw5IcyZM',
        userPoolWebClientId: process.env.REACT_APP_STAGE === "DEV" ? '2eti73lbbk067up2qnhiitmuha' : '5447ckt8dgcca22evaq1v7mpg6'
    },
    Storage: {
        bucket: 'ts-file-storage',
        region: 'us-east-1'
    },
    API: {
        endpoints: [
            {
                name: process.env.REACT_APP_STAGE === "DEV" ? "Node-API" : "prod-api",
                endpoint: process.env.REACT_APP_STAGE === "DEV" ? "https://a36s986nkj.execute-api.us-east-1.amazonaws.com/default/Node-API" : "https://up65cb7sbk.execute-api.us-east-1.amazonaws.com/default/prod-api",
                service: "lambda",
                region: "us-east-1"
            }
        ],
    },
};

export default awsExports;


//
// aws_project_region: 'us-east-1',
// aws_cognito_identity_pool_id: 'us-east-1:470974f8-45bb-439c-aaa0-e29cfddbe2cd',
// aws_cognito_region: 'eu-north-1',
// aws_user_pools_id: 'us-east-1_DWx6rHrCZ',
// aws_user_pools_web_client_id: '5h91qpl5t685bn5esb44eklgiu',